import { Integrations } from '@sentry/tracing';

import { ENV } from '@constants/general';
import { getHostName } from '@helpers/url';

import { appConfig } from '../appConfig';

const appHostRegex = new RegExp(document.location.hostname);
const apiHostRegex = new RegExp(getHostName(appConfig.apiUrl));

export const sentryConfig = {
  environment: ENV,
  dsn: appConfig.sentryDsn,
  ignoreErrors: ['Non-Error promise rejection captured with value: Object Not Found Matching'],
  integrations: [
    new Integrations.BrowserTracing({
      tracingOrigins: ['localhost', appHostRegex, apiHostRegex, /^\//],
    }),
  ],
  release: appConfig.version,
  tracesSampleRate: 0.1,
};
